<template>
  <div v-if="detail">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <p>{{$t('thank-you-rma-submit')}}</p>
        <p>{{$t('provide-rma-number')}}</p>
        <p v-if="!detail.loggedIn">{{$t('retrieve_rma_status.text')}}<a href="javascript:;" v-on:click="openLogin()">{{$t('retrieve_rma_status.link')}}</a>.</p>
      </div>
    </div>
    <!-- Product List -->
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <p><strong>{{$t('product-details')}}</strong> </p>
        <table v-for="(item, index) in detail.products" v-bind:key="item.rmA_LINE_ID">
          <tr>
            <td style="width:200px">{{$t('product')}} {{detail.products.length > 1 ? index + 1 : ''}}</td>
            <td>{{getTranslatedText(item.expecteD_PART_DESC)}}  <span class="rma-status"> {{getStatus(item.rmA_STATUS)}}</span></td>
          </tr>
          <tr v-if="item.expecteD_SERIAL_NO&&item.expecteD_SERIAL_NO.length>0">
            <td style="width:200px">{{$t('serial-number')}}</td>
            <td>{{item.expecteD_SERIAL_NO}}</td>
          </tr>
          <tr v-if="item.datE_OF_PURCHASE_FORMAT&&item.datE_OF_PURCHASE_FORMAT.length>0">
            <td style="width:200px">{{$t('purchase-date')}}</td>
            <td>{{item.datE_OF_PURCHASE_FORMAT}}</td>
          </tr>
          <tr v-if="item.warrantY_EXPIRY_DATE_FORMAT&&item.warrantY_EXPIRY_DATE_FORMAT.length>0&&detail.type==2">
            <td style="width:200px">{{$t('warranty')}}</td>
            <td>{{$t('expires-date', {date: item.warrantY_EXPIRY_DATE_FORMAT})}}</td>
          </tr>
          <tr v-if="getLocation() > -1 ">
            <td style="width:200px">Price</td>
            <td>{{ !parseInt(item.uniT_PRICE) ? '-' : item.uniT_PRICE }}</td>
          </tr>


          <tr>
            <td></td>
            <td style="height:20px;"></td>
          </tr>
        </table>
      </div>
      <div class="md-layout-item md-size-100">
        <p><strong>{{$t('rma-details')}}</strong></p>
        <table>
          <tr>
            <td style="width:200px">{{$t('rma-number')}}</td>
            <td>{{rmaNo}}</td>
          </tr>
          <tr>
            <td>{{$t('service-request2')}}</td>
            <td>
              {{detail.type==1?$t('refund'):$t('replacement')}}
            </td>
          </tr>
        </table>

        <table>
          <tr v-if="detail.type==1&&detail.refundTotalEst.length>0">
            <td style="width:200px;vertical-align:top;">{{$t('refund-amount')}}</td>
            <td style="font-size:1em;">
              {{detail.refundTotalEst}}
            </td>
          </tr>
          <tr>
            <td style="width:200px;vertical-align:top;">{{$t('service-fee')}}</td>
            <td style="font-size:1em;" v-html="$t('service-fee-text')"></td>
          </tr>
          <tr>
            <td colspan="2">
              <table v-if="detail.type==1">
                <tr>
                  <td style="width:200px;">&nbsp;</td>
                  <td>
                    <div>{{$t('refund-estimated-cost')}}</div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

      </div>
    </div>
    <!-- RMA Status History -->
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <p><strong>{{$t('rma-status')}}</strong></p>
      </div>
      <div class="md-layout-item md-size-100" v-if="!cancelled">
        <div class="md-steppers md-vertical md-theme-default">
          <div class="md-steppers-wrapper">
            <div class="md-steppers-container">

              <div class="md-stepper" v-for="item in list" v-bind:key="item.id">
                <div>
                  <div class="md-stepper-header md-theme-default" :class="item.active?'md-active md-done':''">
                    <div class="md-ripple">
                      <div class="md-button-content" style="margin-top:18px;">
                        <div class="md-stepper-number">{{item.id}}</div>
                        <div class="md-stepper-text">
                          <span class="md-stepper-label" :class="item.active ? '' : !list[list.length-1].active ? '' : 'status-msg-hide'">{{item.status}}</span>
                          <span class="md-stepper-description" v-if="item.active">{{item.date}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="md-stepper-content md-active status-text" v-html="item.desc" v-if="item.active"></div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="md-layout-item md-size-100" v-if="cancelled">
        <p>
          {{$t('rma-cancelled')}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import * as types from '../store/mutation-types'
  import { storeUrl } from '../mixins/store'

  export default {
    name: 'RequestSteppers',
    props: {
      detail: Object
    },
    data: () => ({
      active: 'step1',
      list: [],
      rmaNo: '',
      cancelled: false,
      totalRefund: 0
    }),
    computed: {
      ...mapState({
        store: 'store',
        step: 'step'
      })
    },
    methods: {
      ...mapMutations({
        showLogin: types.SHOW_DROP_MENU,
        setupLoginForm: types.CHANGE_DROP_MENU
      }),
      openLogin() {
        this.$scrollTo('#app')
        this.setupLoginForm({ type: 'iframe', url: `${storeUrl(this.store)}/account/signup?layout=no&source=topmenu&e=${this.detail.email}`, height: 'auto' })
        this.showLogin()
      },
      loadStatusText(type) {
        const statusList = type == 1 ? this.$t('refund-status-list', { shippingLabelLink: this.detail.labelLink, display: this.detail.labelStatus == 'S' ? '' : 'display:none;' }) : this.$t('repair-status-list', { shippingLabelLink: this.detail.labelLink, display: this.detail.labelStatus == 'S' ? '' : 'display:none;' })
        const lastStatus = statusList[statusList.length - 1].status
        let result = []

        if (statusList) {
          let i = 1
          for (let item in statusList) {
            //let itemStatus = statusList[item].status;
            let msg = statusList[item].desc;

            msg = msg.replace(/{RefundAmtActual}/gi, this.detail.refundTotalActual)
            if (!this.detail.refundAmountReady) {
              msg = msg.replace(/{showAmount}/gi, "display:none;")
            }

            //window.console.log(this.detail)
            //window.console.log(this.detail.countryCode)
            //window.console.log(this.detail.labelLink)
            //window.console.log(this.detail.labelStatus)
            //window.console.log(this.detail.labelTrackingNo)

            msg = msg.replace(/{display_shippingLabel}/gi, (this.detail.labelStatus == 'S' || this.detail.labelStatus == 'Y') ? '' : 'display:none;').replace(/{courierLabelLink}/gi, this.detail.labelLink)
            //msg = msg.replace(/{msgShipping}/gi, (this.detail.labelStatus == 'S' || this.detail.labelStatus == 'Y') ? '' : 'display:none;').replace(/{msgNoshipping}/gi, this.detail.labelStatus == 'S' ? 'display:none;' : '')

            let display_uk = "none", display_eu = "none", display_others = "block"
            if (this.detail.labelStatus.toUpperCase() == 'Y' || (this.detail.labelStatus.toUpperCase() == 'S')) {
              switch (this.detail.countryCode.toUpperCase()) {
                case 'GB':
                case 'UK':
                  display_uk = "block"
                  display_others = "none"
                  break;

                case 'AU':
                case 'US':
                  display_others = "block"
                  break;

                default:
                  display_eu = "block"
                  display_others = "none"
                  break;
              }

              // ToDo: Build logic for the below
              msg = msg.replace(/{courierLabelLink}/gi, this.detail.labelLink)         // Courier Link, different for UK/EU
              msg = msg.replace(/{orderNumber}/gi, this.detail.rmaNo)                  // Creative RMA No
              msg = msg.replace(/{b2cTrackingNumber}/gi, this.detail.labelTrackingNo)  // B2C Tracking No (For Europe, except UK)
            }
            //window.console.log("display = " + display_eu)
            msg = msg.replace(/{display_uk}/gi, display_uk)
            msg = msg.replace(/{display_eu}/gi, display_eu)
            msg = msg.replace(/{display_others}/gi, display_others)

            // if Replacement
            if (type === 2 && i == statusList.length) {
              if (this.detail.products[0].rmA_METHOD.toUpperCase() === "RN" && this.detail.products[0].rmA_STATUS.toUpperCase() === "CLOSED") {
                statusList[item].status = this.$t('rma-closed');
                msg = "";
              }
              else {
                statusList[item].status = lastStatus;
              }
            }

            result.push({
              id: i,
              status: statusList[item].status,
              date: '',
              desc: msg,
              country: this.detail.countryCode,
              active: false
            })
            i++
          }
        }
        statusList[statusList.length - 1].status = lastStatus
        return result
      },
      getTranslatedText(descText) {
        descText = descText.replace(/Shipping Charges/gi, this.$t('shipping-charge'))
        descText = descText.replace(/Store Credit/gi, this.$t('store-credit'))
        descText = descText.replace(/Tax/gi, this.$t('tax'))
        return descText
      },
      getStatus(statusText) {
        let statusTextFriendly

        switch (statusText.toLowerCase()) {
          case 'not received': statusTextFriendly = this.$t('product-not-received'); break
          case 'canceled': statusTextFriendly = this.$t('product-cancelled'); break
          default: statusTextFriendly = ""

        }
        return (statusTextFriendly !== "") ? `(${statusTextFriendly})` : ""
      },
      getLocation() {
        return location.href.indexOf('localhost')
      },
      getStatusIndex(list, status) {
        return list.indexOf(status)
      },
      getWebFrontStatusIndex(type, index) {
        let result = index;
        if (type == 1) {
          //refund
          switch (index) {
            case 0:
            case 1:
              result = 0 //RMA Request Received
              break;
            case 2:
              result = 1 //RMA Approved
              break;
            case 3:
              result = 2 //Product Received
              break;
            case 4:
            case 5:
            case 6:
              result = 3 //Processing Refund
              break;
            case 7:
              result = 4 //Refund Completed
              break;
          }
        }
        else {
          //replacement
          if (index == 0 || index == 1) result = 0
          else result = index - 1
        }
        return result
      }
    },
    created() {
      if (this.detail) {
        this.rmaNo = this.detail.rmaNo
      }
      //status text
      if (this.detail && this.detail.type)
        this.list = this.loadStatusText(this.detail.type)
      //status history
      if (this.detail && this.detail.history) {
        for (let i = 0; i < this.detail.history.length; i++) {
          let index = this.getWebFrontStatusIndex(this.detail.type, this.getStatusIndex(this.detail.type == 1 ? this.detail.refundStatus : this.detail.replacementStatus, this.detail.history[i].rmA_STATUS))
          if (index >= 0 && this.list[index] && this.list[index].id > 0) {
            this.list[index].active = true
            this.list[index].date = this.detail.history[i].statuS_DATE_FORMAT
          }
        }
      }
      //reorganize status list
      if (this.list && this.list.length > 0) {
        let newList = []
        let activeList = this.list.filter(a => { return a.active })
        if (activeList && activeList.length > 0) {
          const id = activeList[activeList.length - 1].id
          let newId = 1
          for (var i = 0; i < this.list.length; i++) {
            let newItem = { ...this.list[i] }
            if (newItem.id >= id || (newItem.id < id && newItem.active)) {
              newItem.id = newId
              newList.push(newItem)
              newId++
            }
          }
          this.list = newList
        }
      }
      //cancelled
      if (this.detail && this.detail.status == 'Canceled') {
        this.cancelled = true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~vue-material/dist/theme/engine";

  .md-stepper-content p {
    margin: 0;
  }

  .rma-status {
    color: red;
    padding: 0 5px;
    font-size: 0.9em;
  }

  .status-strike-off {
    text-decoration: line-through;
  }

  .status-msg-hide {
    display: none;
  }
</style>
